//  vigation on mobile on/off
var menuButton = document.querySelector('.menu_btn')
var menuOn = document.querySelector('body')

if (menuButton){
  menuButton.addEventListener('click', function() {
    menuOn.classList.toggle('menu-active')
    menuButton.classList.toggle('active')
  });
}